export enum ProjectSettingsDropdownItems {
  BootStrap = 'bootstrap',
  Stripe = 'stripe',
  Iyzico = 'iyzico',
  Authentication = 'authentication',
  Payment = 'payment'
}
